import { AutoCompleteItem } from 'types/api/Common/AutoCompleteTypes';

export interface InsighViewDefinitionDetails {
  id: string;
  name: string;
  subject: AutoCompleteItem;
  cube: AutoCompleteItem;
  insightViewType: string;
  dataSetType: string;
  attributeDefinitions: InsightViewAttributeItem[];
  varianceDefinitions: InsightViewVarianceItem[];
  cellColorDefinitions: InsightViewCellColorItem[];
  cubeAttributeIds: string[];
  cubeExcludedAttributeIds: string[];
}

export interface InsightViewAttributeItem {
  id: string;
  name: string;
  displayName?: string | null;
  isNew?: boolean;
  isGroup: boolean;
  relativePeriod: number | null;
  relativePeriodType: string | null;
  relativeYear: number | null;
  relativeYearType: string | null;
  cubeLayer: AutoCompleteItem | null;
  totalRule: AutoCompleteItem | null;
  totalRulePeriodCount: number | null;
  accumulationRule: AutoCompleteItem | null;
  group: AutoCompleteItem | null;
  groupTopHeaderType: string | null;
  order?: number;
  showRankColumn?: boolean;
  showPercentageTotalColumn?: boolean;
}

export interface InsightViewVarianceItem {
  id: string;
  order?: number;
  group: AutoCompleteItem | null;
  targetColumn: AutoCompleteItem | null;
  resultColumn: AutoCompleteItem | null;
  groupDisplayType?: InsightViewVarianceGroupDisplayType | null;
  varianceDisplayType?: InsightViewVarianceDisplayType | null;
  headerName?: string | null;
  displayName?: string | null;
  weight?: number | null;
}

export enum InsightViewVarianceGroupDisplayType {
  EXISTING_GROUP = 'EXISTING_GROUP',
  OWN_GROUP = 'OWN_GROUP',
}

export enum InsightViewVarianceDisplayType {
  VAR_ONLY = 'VAR_ONLY',
  VAR_PERCENTAGE_ONLY = 'VAR_PERCENTAGE_ONLY',
  BOTH = 'BOTH',
}

export enum InsightViewCellColorCondition {
  LESS_THAN = 'LESS_THAN',
  GREATER_THAN = 'GREATER_THAN',
  EQUAL = 'EQUAL',
  NUMERIC_GREATER_THAN_OR_EQUAL = 'NUMERIC_GREATER_THAN_OR_EQUAL',
  NUMERIC_LESS_THAN_OR_EQUAL = 'NUMERIC_LESS_THAN_OR_EQUAL',
  BETWEEN = 'BETWEEN',
}

export interface InsightViewCellColorItem {
  id: string | null;
  cubeAttribute: AutoCompleteItem | null;
  rules: InsightViewCellColorRuleItem[];
}

export interface InsightViewLimitAttributeItem {
  cubeAttributeIds: string[];
}

export interface InsightViewCellColorRuleItem {
  id: string | null;
  value: string | null;
  minValue: string | null;
  maxValue: string | null;
  includeMin: boolean;
  includeMax: boolean;
  priorityOrder: number;
  color: AutoCompleteItem | null;
  condition: AutoCompleteItem | null;
  attributeReference: AutoCompleteItem | null;
}

export type RequestInsightViewAttributeItem = Omit<
  InsightViewAttributeItem,
  'cubeLayer' | 'group' | 'totalRule' | 'accumulationRule'
> & {
  cubeLayerId: string | null;
  groupId: string | null;
  totalRule: string | null;
  accumulationRule: string | null;
  order: number;
};

export type RequestInsightViewVarianceItem = Omit<
  InsightViewVarianceItem,
  'group' | 'targetColumn' | 'resultColumn'
> & {
  groupId: string | null;
  targetColumnId: string | null;
  resultColumnId: string | null;
};

export type RequestInsightViewCellColorItem = Omit<
  InsightViewCellColorItem,
  'cubeAttribute' | 'greaterThanColor' | 'lessThanColor'
> & {
  cubeAttributeId: string;
};

export interface RequestCreateInsightViewDefinition {
  name: string;
  cubeId: string;
  insightViewType: string;
  dataSetType: string;
  attributeDefinitions: RequestInsightViewAttributeItem[];
  varianceDefinitions: RequestInsightViewVarianceItem[];
  cellColorDefinitions: RequestInsightViewCellColorItem[];
  cubeAttributeIds: string[];
}

export interface RequestEditInsightViewDefinition extends RequestCreateInsightViewDefinition {
  id: string;
}
